class ProductTabs {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.product-tabs__tab');
    this.contents = container.querySelectorAll('.product-tabs__content');
    this.prevButton = container.querySelector('.product-tabs__nav-button.prev');
    this.nextButton = container.querySelector('.product-tabs__nav-button.next');
    this.currentTabIndex = 0;

    this.init();
  }

  init() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.setActiveTab(index));
    });

    this.prevButton?.addEventListener('click', () => this.navigateTab('prev'));
    this.nextButton?.addEventListener('click', () => this.navigateTab('next'));
    this.updateNavigationButtons();
  }

  setActiveTab(index) {
    this.tabs.forEach(tab => tab.classList.remove('active'));
    this.contents.forEach(content => content.classList.remove('active'));
    
    this.tabs[index].classList.add('active');
    this.contents[index].classList.add('active');
    this.currentTabIndex = index;
    this.updateNavigationButtons();
  }

  navigateTab(direction) {
    if (direction === 'prev') {
      this.currentTabIndex = (this.currentTabIndex - 1 + this.tabs.length) % this.tabs.length;
    } else {
      this.currentTabIndex = (this.currentTabIndex + 1) % this.tabs.length;
    }
    
    this.setActiveTab(this.currentTabIndex);
  }

  updateNavigationButtons() {
    this.prevButton?.classList.toggle('disabled-arrow', this.currentTabIndex === 0);
    this.nextButton?.classList.toggle('disabled-arrow', this.currentTabIndex === this.tabs.length - 1);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const productTabContainers = document.querySelectorAll('.product-tabs');
  productTabContainers.forEach(container => new ProductTabs(container));
});
